import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { collectionLandingTabs } from '../../../routes/sales';

const CollectionLandingView = () => {
  const tabs = collectionLandingTabs();
  return <FingoPaper tabs={tabs} />;
};

export default CollectionLandingView;
